import { defineStore } from 'pinia'

export const useDocsStore = defineStore('docs', {
  state: () => ({
    statusList: {
      1: 'Выставлен', // Счет
      2: 'Оплачен', // Счет
      3: 'Новый', // Акт
      4: 'Подписан', // Акт
    },
    list: []
  }),
  actions: {
    setList(list) {
      this.list = list || []
    }
  },
})
